import {useCallback} from 'react';
import api from 'api';
import {usePostApi} from 'common/hooks/usePostApi';
import {
   IFilterTransactions,
   FilterTransactionType,
   FilterTransactionsNames,
} from 'types/diplomat/FilterTransactions';
import {DataRow, removeCyclesAndMerge} from './removeCyclesAndMerge';

type IResponse = DataRow[]; // (string | number)[][];

const options = {
   // transformData: transformDataFromArray,
   transformData: removeCyclesAndMerge,
};

export const useFetchHipaaData = (onSuccess: () => void) => {
   const {request, state: data} = usePostApi<IResponse>(api.connectionmap, options);

   const fetchData = useCallback(
      (filterData?: IFilterTransactions) => {
         const transactionids =
            filterData &&
            !filterData._byPartners &&
            filterData._type === FilterTransactionType.enum.SELECTED
               ? filterData.transactions.map((t) => t.id)
               : null;
         const partnerids =
            filterData &&
            filterData._byPartners &&
            filterData._type === FilterTransactionType.enum.SELECTED
               ? filterData.partners.map((t) => t.id)
               : null;

         request(
            JSON.stringify({
               transactionids,
               partnerids,
               [FilterTransactionsNames.activeOnly]: filterData ? filterData.activeOnly : true,
            }),
            {onSuccess}
         );
      },
      [request, onSuccess]
   );

   return {fetchData, data};
};
